import { render, staticRenderFns } from "./VoucherApplyModal.vue?vue&type=template&id=4b56a676"
import script from "./VoucherApplyModal.vue?vue&type=script&lang=js"
export * from "./VoucherApplyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports